var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3406_85577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.083 0H6.58301C4.9254 0 3.33569 0.65848 2.16359 1.83058C0.991488 3.00269 0.333008 4.5924 0.333008 6.25L0.333008 13.75C0.333008 15.4076 0.991488 16.9973 2.16359 18.1694C3.33569 19.3415 4.9254 20 6.58301 20H14.083C15.7406 20 17.3303 19.3415 18.5024 18.1694C19.6745 16.9973 20.333 15.4076 20.333 13.75V6.25C20.333 4.5924 19.6745 3.00269 18.5024 1.83058C17.3303 0.65848 15.7406 0 14.083 0ZM18.458 13.75C18.458 16.1625 16.4955 18.125 14.083 18.125H6.58301C4.17051 18.125 2.20801 16.1625 2.20801 13.75V6.25C2.20801 3.8375 4.17051 1.875 6.58301 1.875H14.083C16.4955 1.875 18.458 3.8375 18.458 6.25V13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 5C9.00693 5 7.73516 5.52678 6.79747 6.46447C5.85979 7.40215 5.33301 8.67392 5.33301 10C5.33301 11.3261 5.85979 12.5979 6.79747 13.5355C7.73516 14.4732 9.00693 15 10.333 15C11.6591 15 12.9309 14.4732 13.8685 13.5355C14.8062 12.5979 15.333 11.3261 15.333 10C15.333 8.67392 14.8062 7.40215 13.8685 6.46447C12.9309 5.52678 11.6591 5 10.333 5ZM10.333 13.125C9.50451 13.124 8.71023 12.7944 8.1244 12.2086C7.53856 11.6228 7.209 10.8285 7.20801 10C7.20801 8.27625 8.61051 6.875 10.333 6.875C12.0555 6.875 13.458 8.27625 13.458 10C13.458 11.7225 12.0555 13.125 10.333 13.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.708 5.29126C16.076 5.29126 16.3742 4.99297 16.3742 4.62501C16.3742 4.25705 16.076 3.95876 15.708 3.95876C15.34 3.95876 15.0417 4.25705 15.0417 4.62501C15.0417 4.99297 15.34 5.29126 15.708 5.29126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3406_85577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7d4cf8e7420d4d19ef10ee41185b89b0.svg";
export { ForwardRef as ReactComponent };